/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseDataSourceToMerge } from './GetSourceMergePreview200ResponseDataSourceToMerge';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeToJSON,
} from './GetSourceMergePreview200ResponseDataSourceToMerge';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseData
 */
export interface GetSourceMergePreview200ResponseData {
    /**
     * 
     * @type {GetSourceMergePreview200ResponseDataSourceToMerge}
     * @memberof GetSourceMergePreview200ResponseData
     */
    source_to_merge: GetSourceMergePreview200ResponseDataSourceToMerge;
    /**
     * 
     * @type {GetSourceMergePreview200ResponseDataSourceToMerge}
     * @memberof GetSourceMergePreview200ResponseData
     */
    merged_source?: GetSourceMergePreview200ResponseDataSourceToMerge;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseData interface.
 */
export function instanceOfGetSourceMergePreview200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source_to_merge" in value;

    return isInstance;
}

export function GetSourceMergePreview200ResponseDataFromJSON(json: any): GetSourceMergePreview200ResponseData {
    return GetSourceMergePreview200ResponseDataFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source_to_merge': GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json['source_to_merge']),
        'merged_source': !exists(json, 'merged_source') ? undefined : GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json['merged_source']),
    };
}

export function GetSourceMergePreview200ResponseDataToJSON(value?: GetSourceMergePreview200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_to_merge': GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value.source_to_merge),
        'merged_source': GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value.merged_source),
    };
}

